/***** Javascript for Dynamic Content Carousel ******/

$(document).ready(function () {
    var dynamicContentWindowWidthCal = $(window).width();
    var isScrollBarCal = $(document).height() > $(window).height();
    var transitionWidthCal = isScrollBarCal ? 950 : 960;

    if (dynamicContentWindowWidthCal >= transitionWidthCal) 
        initializeCarouselForDesktop();
    else if (dynamicContentWindowWidthCal > 767)
        initializeCarouselForTablet();
    else {
        initializeCarouselForMobile();
    }

    // For Preview mode method in Manage Dynamic Content.
    window.initializeCarousels = function() {
        if (dc.mode === 'preview') {
            if ($(window).width() > 959)
                initializeCarouselForDesktop();
            else if ($(window).width() > 767)
                initializeCarouselForTablet();
            else
                initializeCarouselForMobile();
        } else {
            stopCarouselForDesktop();
            stopCarouselForTablet();
            stopCarouselForMobile();
        }
    };

    function stopCarouselForDesktop() {
        $('.desktop-carousel').each(function () {
            if (!$(this).hasClass('mobile-carousel') && $(this).find('.carousel-inner').length > 0)
                stopCarousel($(this));
        });

    }

    function stopCarouselForTablet() {
        $('.tablet-carousel').each(function () {
            if (!$(this).hasClass('tablet-carousel') && $(this).find('.carousel-inner').length > 0)
                stopCarousel($(this));
        });
    }

    function stopCarouselForMobile() {
        $('.mobile-carousel').each(function () {
            if (!$(this).hasClass('desktop-carousel') && $(this).find('.carousel-inner').length > 0)
                stopCarousel($(this));
        });
    }


    function initializeCarouselForDesktop() {
        $('.desktop-carousel').each(function() {
            if ($(this).find('.carousel-inner').length == 0) {
                var id = $(this).attr('id');
                var duration = $(this).attr("data-desktop-carouselduration");
                initializeCarousel($(this), id, duration);
            }
        });
    }

    function initializeCarouselForTablet() {
        $('.tablet-carousel').each(function () {
            if ($(this).find('.carousel-inner').length == 0) {
                var id = $(this).attr('id');
                var duration = $(this).attr("data-tablet-carouselduration");
                initializeCarousel($(this), id, duration);
            }
        });
    }

    function initializeCarouselForMobile() {
        $('.mobile-carousel').each(function () {
            if ($('.mobile-carousel').find('.carousel-inner').length != 0)
                return;

            var id = $(this).attr('id');
            var duration = $(this).attr("data-mobile-carouselduration");
            initializeCarousel($(this), id, duration);
        });
    }

    function initializeCarousel(elm, id, duration) {
        if (elm.find('.carousel-inner').length != 0)
            return;

        elm.addClass('carousel').addClass('slide');
        elm.find(".dynamic-content2-item").addClass('item').wrapAll("<div class='carousel-inner' />");
        elm.find(".dynamic-content2-item").eq(0).addClass('active');
        elm.find('.carousel-inner').after('<a class="carousel-control left" href="#' + id + '" data-slide="prev">&lsaquo;</a><a class="carousel-control right" href="#' + id + '" data-slide="next">&rsaquo;</a>');
        if (duration != undefined && duration > 0) {
            duration = duration >= 1000 ? duration : duration * 1000;
            elm.carousel({ interval: duration });
        }
        else {
            elm.carousel();
        }
    }

    function stopCarousel(elm) {
        if (elm.find('.carousel-inner').length > 0) {
            elm.carousel({
                interval: false
            });
            elm.find('.dynamic-content2-item').unwrap();
            elm.find('.carousel-inner').removeClass('carousel-inner');
            elm.removeClass('carousel').removeClass('slide');
            elm.find(".dynamic-content2-item").removeClass('item');
            elm.find(".dynamic-content2-item").removeClass('active');

            elm.find('.carousel-control').remove();
        }

    }
});

var waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();


/*!
 * Bootstrap v3.3.4 (http://getbootstrap.com)
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

/*!
 * Generated using the Bootstrap Customizer (http://getbootstrap.com/customize/?id=7b58d77dc5667017aa45)
 * Config saved to config.json and https://gist.github.com/7b58d77dc5667017aa45
 */
if (typeof jQuery === 'undefined') {
    throw new Error('Bootstrap\'s JavaScript requires jQuery')
}
+function ($) {
    'use strict';
    var version = $.fn.jquery.split(' ')[0].split('.')
    if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1)) {
        throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher')
    }
}(jQuery);

/* ========================================================================
 * Bootstrap: carousel.js v3.3.4
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // CAROUSEL CLASS DEFINITION
    // =========================

    var Carousel = function (element, options) {
        this.$element = $(element)
        this.$indicators = this.$element.find('.carousel-indicators')
        this.options = options
        this.paused = null
        this.sliding = null
        this.interval = null
        this.$active = null
        this.$items = null

        this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

        this.options.pause == 'hover' && this.$element
          .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
          .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
    }

    Carousel.VERSION = '3.3.4'

    Carousel.TRANSITION_DURATION = 600

    Carousel.DEFAULTS = {
        interval: 5000,
        pause: 'hover',
        wrap: true,
        keyboard: true
    }

    Carousel.prototype.keydown = function (e) {
        if (/input|textarea/i.test(e.target.tagName)) return
        switch (e.which) {
            case 37: this.prev(); break
            case 39: this.next(); break
            default: return
        }

        e.preventDefault()
    }

    Carousel.prototype.cycle = function (e) {
        e || (this.paused = false)

        this.interval && clearInterval(this.interval)

        this.options.interval
          && !this.paused
          && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

        return this
    }

    Carousel.prototype.getItemIndex = function (item) {
        this.$items = item.parent().children('.item')
        return this.$items.index(item || this.$active)
    }

    Carousel.prototype.getItemForDirection = function (direction, active) {
        var activeIndex = this.getItemIndex(active)
        var willWrap = (direction == 'prev' && activeIndex === 0)
                    || (direction == 'next' && activeIndex == (this.$items.length - 1))
        if (willWrap && !this.options.wrap) return active
        var delta = direction == 'prev' ? -1 : 1
        var itemIndex = (activeIndex + delta) % this.$items.length
        return this.$items.eq(itemIndex)
    }

    Carousel.prototype.to = function (pos) {
        var that = this
        var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

        if (pos > (this.$items.length - 1) || pos < 0) return

        if (this.sliding) return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
        if (activeIndex == pos) return this.pause().cycle()

        return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
    }

    Carousel.prototype.pause = function (e) {
        e || (this.paused = true)

        if (this.$element.find('.next, .prev').length && $.support.transition) {
            this.$element.trigger($.support.transition.end)
            this.cycle(true)
        }

        this.interval = clearInterval(this.interval)

        return this
    }

    Carousel.prototype.next = function () {
        if (this.sliding) return
        return this.slide('next')
    }

    Carousel.prototype.prev = function () {
        if (this.sliding) return
        return this.slide('prev')
    }

    Carousel.prototype.slide = function (type, next) {
        var $active = this.$element.find('.item.active')
        var $next = next || this.getItemForDirection(type, $active)
        var isCycling = this.interval
        var direction = type == 'next' ? 'left' : 'right'
        var that = this

        if ($next.hasClass('active')) return (this.sliding = false)

        var relatedTarget = $next[0]
        var slideEvent = $.Event('slide.bs.carousel', {
            relatedTarget: relatedTarget,
            direction: direction
        })
        this.$element.trigger(slideEvent)
        if (slideEvent.isDefaultPrevented()) return

        this.sliding = true

        isCycling && this.pause()

        if (this.$indicators.length) {
            this.$indicators.find('.active').removeClass('active')
            var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
            $nextIndicator && $nextIndicator.addClass('active')
        }

        var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
        if ($.support.transition && this.$element.hasClass('slide')) {
            $next.addClass(type)
            $next[0] && $next[0].offsetWidth // force reflow ??
            $active.addClass(direction)
            $next.addClass(direction)
            $active
              .one('bsTransitionEnd', function () {
                  $next.removeClass([type, direction].join(' ')).addClass('active')
                  $active.removeClass(['active', direction].join(' '))
                  that.sliding = false
                  setTimeout(function () {
                      that.$element.trigger(slidEvent)
                  }, 0)
              })
              .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
        } else {
            $active.removeClass('active')
            $next.addClass('active')
            this.sliding = false
            this.$element.trigger(slidEvent)
        }

        isCycling && this.cycle()

        return this
    }


    // CAROUSEL PLUGIN DEFINITION
    // ==========================

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this)
            var data = $this.data('bs.carousel')
            var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
            var action = typeof option == 'string' ? option : options.slide

            if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
            if (typeof option == 'number') data.to(option)
            else if (action) data[action]()
            else if (options.interval) data.pause().cycle()
        })
    }

    var old = $.fn.carousel

    $.fn.carousel = Plugin
    $.fn.carousel.Constructor = Carousel


    // CAROUSEL NO CONFLICT
    // ====================

    $.fn.carousel.noConflict = function () {
        $.fn.carousel = old
        return this
    }


    // CAROUSEL DATA-API
    // =================

    var clickHandler = function (e) {
        var href
        var $this = $(this)
        var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
        if (!$target.hasClass('carousel')) return
        var options = $.extend({}, $target.data(), $this.data())
        var slideIndex = $this.attr('data-slide-to')
        if (slideIndex) options.interval = false

        Plugin.call($target, options)

        if (slideIndex) {
            $target.data('bs.carousel').to(slideIndex)
        }

        e.preventDefault()
    }

    $(document)
      .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
      .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

    $(window).on('load', function () {
        $('[data-ride="carousel"]').each(function () {
            var $carousel = $(this)
            Plugin.call($carousel, $carousel.data())
        })
    })

}(jQuery);




/* ========================================================================
 * Bootstrap: transition.js v3.3.4
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
    'use strict';

    // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
    // ============================================================

    function transitionEnd() {
        var el = document.createElement('bootstrap')

        var transEndEventNames = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend'
        }

        for (var name in transEndEventNames) {
            if (el.style[name] !== undefined) {
                return { end: transEndEventNames[name] }
            }
        }

        return false // explicit for ie8 (  ._.)
    }

    // http://blog.alexmaccaw.com/css-transitions
    $.fn.emulateTransitionEnd = function (duration) {
        var called = false
        var $el = this
        $(this).one('bsTransitionEnd', function () { called = true })
        var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
        setTimeout(callback, duration)
        return this
    }

    $(function () {
        $.support.transition = transitionEnd()

        if (!$.support.transition) return

        $.event.special.bsTransitionEnd = {
            bindType: $.support.transition.end,
            delegateType: $.support.transition.end,
            handle: function (e) {
                if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
            }
        }
    })

}(jQuery);

/* ========================================================================
 * bootstrap-carousel-swipe v0.0.6
 * https://github.com/avinoamr/bootstrap-carousel-swipe
 * ======================================================================== */

+function ($) {
    'use strict';

    if (!$.fn.carousel) {
        throw new Error("carousel-swipe required bootstrap carousel")
    }

    // CAROUSEL CLASS DEFINITION
    // =========================

    var CarouselSwipe = function (element) {
        this.$element = $(element)
        this.carousel = this.$element.data('bs.carousel')
        this.options = $.extend({}, CarouselSwipe.DEFAULTS, this.carousel.options)
        this.startX =
        this.startY =
        this.startTime =
        this.cycling =
        this.$active =
        this.$items =
        this.$next =
        this.$prev =
        this.dx = null

        this.$element
          .on('touchstart', $.proxy(this.touchstart, this))
          .on('touchmove', $.proxy(this.touchmove, this))
          .on('touchend', $.proxy(this.touchend, this))
    }

    CarouselSwipe.DEFAULTS = {
        swipe: 50 // percent per second
    }

    CarouselSwipe.prototype.touchstart = function (e) {
        if (!this.options.swipe) return;
        var touch = e.originalEvent.touches ? e.originalEvent.touches[0] : e
        this.dx = 0
        this.startX = touch.pageX
        this.startY = touch.pageY
        this.cycling = null
        this.width = this.$element.width()
        this.startTime = e.timeStamp
    }

    CarouselSwipe.prototype.touchmove = function (e) {
        if (!this.options.swipe) return;
        var touch = e.originalEvent.touches ? e.originalEvent.touches[0] : e
        var dx = touch.pageX - this.startX
        var dy = touch.pageY - this.startY
        if (Math.abs(dx) < Math.abs(dy)) return; // vertical scroll

        if (this.cycling === null) {
            this.cycling = !!this.carousel.interval
            this.cycling && this.carousel.pause()
        }

        e.preventDefault()
        this.dx = dx / (this.width || 1) * 100
        this.swipe(this.dx)
    }

    CarouselSwipe.prototype.touchend = function (e) {
        if (!this.options.swipe) return;
        if (!this.$active) return; // nothing moved
        var all = $()
          .add(this.$active).add(this.$prev).add(this.$next)
          .carousel_transition(true)

        var dt = (e.timeStamp - this.startTime) / 1000
        var speed = Math.abs(this.dx / dt) // percent-per-second
        if (this.dx > 40 || (this.dx > 0 && speed > this.options.swipe)) {
            this.carousel.prev()
        } else if (this.dx < -40 || (this.dx < 0 && speed > this.options.swipe)) {
            this.carousel.next();
        } else {
            this.$active
              .one($.support.transition.end, function () {
                  all.removeClass('prev next')
              })
            .emulateTransitionEnd(this.$active.css('transition-duration').slice(0, -1) * 1000)
        }

        all.css('left', '')
        this.cycling && this.carousel.cycle()
        this.$active = null // reset the active element
    }

    CarouselSwipe.prototype.swipe = function (percent) {
        var $active = this.$active || this.getActive()
        if (percent < 0) {
            this.$prev
                .css('left', '')
                .removeClass('prev')
                .carousel_transition(true)
            if (!this.$next.length || this.$next.hasClass('active')) return
            this.$next
                .carousel_transition(false)
                .addClass('next')
                .css('left', (percent + 100) + '%')
        } else {
            this.$next
                .css('left', '')
                .removeClass('next')
                .carousel_transition(true)
            if (!this.$prev.length || this.$prev.hasClass('active')) return
            this.$prev
                .carousel_transition(false)
                .addClass('prev')
                .css('left', (percent - 100) + '%')
        }

        $active
            .carousel_transition(false)
            .css('left', percent + '%')
    }

    CarouselSwipe.prototype.getActive = function () {
        this.$active = this.$element.find('.item.active')
        this.$items = this.$active.parent().children()

        this.$next = this.$active.next()
        if (!this.$next.length && this.options.wrap) {
            this.$next = this.$items.first();
        }

        this.$prev = this.$active.prev()
        if (!this.$prev.length && this.options.wrap) {
            this.$prev = this.$items.last();
        }

        return this.$active;
    }

    // CAROUSEL PLUGIN DEFINITION
    // ==========================

    var old = $.fn.carousel
    $.fn.carousel = function () {
        old.apply(this, arguments);
        return this.each(function () {
            var $this = $(this)
            var data = $this.data('bs.carousel.swipe')
            if (!data) $this.data('bs.carousel.swipe', new CarouselSwipe(this))
        })
    }

    $.extend($.fn.carousel, old);

    $.fn.carousel_transition = function (enable) {
        enable = enable ? '' : 'none';
        return this.each(function () {
            $(this)
              .css('-webkit-transition', enable)
              .css('transition', enable)
        })
    };

}(jQuery);


/** WEBPACK FOOTER **
 ** ./DynamicContent2Style/Carousel.js
 **/